import * as types from "./relation.types";

const initialState = {
	relation_notify: null,
};

export default function relation_reducer(state = initialState, action) {
	switch (action.type) {
		// RELATION NOTIFY
		case types.RELATION_NOTIFY:
			return { ...state, relation_notify: action.payload };
		case types.RELATION_NOTIFY_UNSET:
			return { ...state, relation_notify: null };

		default:
			return state;
	}
}
